import { render, staticRenderFns } from "./NewsAdd.vue?vue&type=template&id=44b58d0b&scoped=true&"
import script from "./NewsAdd.vue?vue&type=script&lang=js&"
export * from "./NewsAdd.vue?vue&type=script&lang=js&"
import style0 from "./NewsAdd.vue?vue&type=style&index=0&id=44b58d0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b58d0b",
  null
  
)

export default component.exports